import { lazy } from 'react';
const GatePassSecurity = lazy(() => import('./GatePassSecurity'));

const GatePassSecurityRoutes = [
  {
    path: '/gate-pass-security',
    component: GatePassSecurity
  }
];
export default GatePassSecurityRoutes;
